import React from "react";
import styled from "styled-components";
import { motion } from "framer-motion";
import {
  pageAnimation,
  fade,
  lineAnimation,
  slider,
  sliderContainer,
} from "../animation";
import ScrollTop from "../components/ScrollTop";

const CustomerService = styled(motion.div)`
  min-height: 100vh;
  overflow: hidden;
  padding: 5rem 10rem;
  background-color: rgb(255, 54, 54);
  h2 {
    padding: 1rem 0;
  }
  p {
    padding: 1rem 0;
    line-height: 1.5;
  }
  @media only screen and (min-width: 821px) and (max-width: 1200px) {
    padding: 3rem 5rem;
  }
  /* Kindle and iPad tablet  */
  @media only screen and (min-width: 540px) and (max-width: 820px) {
    padding: 3rem 2.5rem;
  }
  /* Mobile devices iPhone, Pixel */
  @media only screen and (min-width: 320px) and (max-width: 539px) {
    padding: 2.5rem 1rem;
    h2 {
      font-size: 3rem;
      text-align: center;
    }
  }
`;

const OurCustomerService = () => {
  return (
    <CustomerService variants={pageAnimation} initial="hidden" animate="show" exit="exit">
      <>
        <motion.div variants={sliderContainer}></motion.div>
        <Frame1 variants={slider}></Frame1>
        <Frame2 variants={slider}></Frame2>
        <Frame3 variants={slider}></Frame3>
        <Frame4 variants={slider}></Frame4>
        <motion.h2 variants={fade}>Our Customer Service</motion.h2>
        <motion.div variants={lineAnimation} className="line"></motion.div>
        <motion.p variants={fade}>
          At Burgred, exceptional customer service is just as important as the quality of our food. We believe that every guest should feel valued and welcomed, and our staff is dedicated to providing a warm, friendly, and attentive experience from the moment you walk through our doors.
        </motion.p>
        <motion.p variants={fade}>
          Our highly trained team takes the time to ensure that every customer feels at home. We pride ourselves on being knowledgeable and passionate about what we serve, and answering any questions you may have.
        </motion.p>
        <motion.p variants={fade}>
          At Burgred, we understand that great service is about more than just taking orders—it's about creating a memorable dining experience. We go above and beyond to accommodate dietary preferences and ensure that each guest's needs are met with a smile. Whether you're enjoying a casual meal with friends, celebrating a special occasion, or picking up a quick bite, our team is committed to delivering a seamless and enjoyable experience.
        </motion.p>
        <ScrollTop />
      </>
    </CustomerService>
  );
};

export default OurCustomerService;

const Frame1 = styled(motion.div)`
  position: fixed;
  left: 0;
  top: 10%;
  width: 100%;
  height: 100vh;
  background-color: #fffebf;
  z-index: 2;
`;
const Frame2 = styled(Frame1)`
  background-color: #ff8efb;
`;
const Frame3 = styled(Frame1)`
  background-color: #8ed2ff;
`;
const Frame4 = styled(Frame1)`
  background-color: #8effa0;
`;
